import { render, staticRenderFns } from "./DecompositionRevenues.vue?vue&type=template&id=66de147a"
import script from "./DecompositionRevenues.vue?vue&type=script&lang=js"
export * from "./DecompositionRevenues.vue?vue&type=script&lang=js"
import style0 from "./DecompositionRevenues.vue?vue&type=style&index=0&id=66de147a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports